import React, { useCallback, useState } from 'react';
import CommandPalette from 'components/common/CommandPalette';
import { useBuscarProdutosNFe } from '../../../../hooks/useNFe';
import { BuscarProdutosNFeItem } from '../../../../types/nfe';

interface Props {
  show: boolean;
  onHide: () => void;
  onSelecionar: (produto: BuscarProdutosNFeItem) => void;
  onExited?: () => void;
}

const fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

const ModalBuscarProdutoNFe: React.FC<Props> = ({ show, onHide, onSelecionar, onExited }) => {
  const [termo, setTermo] = useState('');
  const query = useBuscarProdutosNFe(termo, show && termo.length >= 2);

  const handleSearch = useCallback((t: string) => setTermo(t), []);

  const handleSelect = useCallback((produto: BuscarProdutosNFeItem) => {
    onSelecionar(produto);
  }, [onSelecionar]);

  return (
    <CommandPalette
      show={show}
      onHide={onHide}
      onExited={onExited}
      onSearch={handleSearch}
      items={query.data ?? []}
      isFetching={query.isFetching}
      isSuccess={query.isSuccess}
      onSelect={handleSelect}
      getKey={p => p.id}
      placeholder="Código, descrição ou EAN..."
      emptyMessage="Nenhum produto encontrado"
      minChars={2}
      renderRow={produto => (
        <>
          <span className="cmd-row__doc">{produto.codigo}</span>
          <span className="cmd-row__name">{produto.descricao}</span>
          {produto.unidade && (
            <span style={{ fontSize: '0.68rem', color: 'var(--cmd-muted)', flexShrink: 0 }}>
              {produto.unidade}
            </span>
          )}
          <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '0.75rem', color: 'var(--cmd-text)', flexShrink: 0 }}>
            {fmt.format(produto.valor)}
          </span>
        </>
      )}
    />
  );
};

export default ModalBuscarProdutoNFe;
